module.exports = __webpack_public_path__ + "img/marker_agent.96c7303.svg";